export function Section4Terrain() {
  return (
    <div className="copy-block narrow" data-motion="reveal">
      <p className="eyebrow mono">RATES SURFACE</p>
      <h2>The shape of risk-free, four ways.</h2>
      <p>
        US, Germany, Japan, and the UK are rendered as a terrain surface. Inversions
        rise as visible topology, not footnotes.
      </p>
    </div>
  )
}
